import React from 'react'
import ProgressCard from '../../../../../common/card/ProgressCard'
import { useUserReport } from '../../../ReportingGroup/context/UserReportContext'
import { getLastActivity } from '../../../ReportingGroup/utils'

const UserStats = () => {
  const { selectedUser } = useUserReport()

  const userStats = [
    {
        'title': 'enrolled', 
        'value': selectedUser.enrolledCount ?? 0,
    },
    {
        'title': 'not started', 
        'value': selectedUser.notStartedCount ?? 0,
    },
    {
        'title': 'completed', 
        'value': selectedUser.completedCount ?? 0,
        'color': '#0E9F6E',
    },
    {
        'title': 'in progress', 
        'value': selectedUser.inProgressCount ?? 0,
    }
  ]
  
  const lastActivity = getLastActivity( selectedUser )
  
  return (
    <div className='msync-reporting__detail__overview msync-report-user-profile'>
        <div className='msync-reporting__detail__overview__content'>
            <div className='msync-reporting__detail__overview__part msync-report-user-profile__user'>
                <div className='msync-reporting__detail__overview__part__title'>Profile</div>
                <div className='msync-reporting__detail__overview__part__content'>
                    <img src={selectedUser.avatarUrl} alt={selectedUser.name} className='msync-report-user-profile__user__img' />
                    <div className='msync-report-user-profile__user__details'>
                        <div className='msync-report-user-profile__user__details__fullname'>{ selectedUser.name }</div>
                        <div className='msync-report-user-profile__user__details__email'>{ selectedUser.email }</div>
                        <div className='msync-report-user-profile__user__details__last-seen'>{ lastActivity }</div>
                    </div>
                </div>
            </div>
            <div className='msync-reporting__detail__overview__part msync-report-user-profile__progress'>
                <div className="msync-reporting__detail__overview__part__title">Overview</div>
                <div className="msync-reporting__detail__overview__part__content">
                    { userStats.map((progress, key) => (
                            <ProgressCard content={progress} key={key} />
                    )) }
                </div>
            </div>
        </div>
    </div>
  )
}

export default UserStats
